export const STEP_INFO = {
  localizationKeyPrefix:
    'Geographic::StandCycleRotationHarvestPreparation.StepCompleteOtherParameters',
};

export const ERROR_MODAL_OPTIONS = {
  centered: true,
  size: 'lg'
};

export const COLUMN_HEADER_KEYS = {
  stand: 'Planning::Entity.Stand.Name',
  cycle: 'Geographic::Entity.Cycle',
  rotation: 'Geographic::Entity.Rotation',
  area: 'Planning::Entity.Stand.StandArea',
  applyHerbicide: 'Geographic::Entity.StandCycleRotation.ApplyHerbicide',
  stumpCandidateToRegrowth: 'Geographic::Entity.StandCycleRotation.IsStumpCandidateToRegrowth',
  standStatus: 'Geographic::Entity.StandCycleRotation.StandStatus',
  landContractType: 'Geographic::Entity.StandCycleRotation.LandContractType',
  forestContractType: 'Geographic::Entity.StandCycleRotation.ForestContractType',
  applyFeller: 'Geographic::Entity.StandCycleRotation.ApplyFeller',
  measurementType: 'WoodSupply::Entity.MeasurementType',
  showError: 'Geographic::StandCycleRotationHarvestPreparation.ShowErrorLabel'
};
